module.exports = "/images/_/_/_/_/site/resources/js/src/assets/images/pages/login-v2-dark.svg";